export const getCipherHeader = () => {
  const CryptoJS = require("crypto-js");
  const Ciphertext = CryptoJS.AES.encrypt("APPBAY_techbase_mlm", 'pXe*u%mG3#k7ZFDj8H3wMDKkZ').toString()
  return Ciphertext
}